import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import HomePage from './pages/HomePage';
import VehicleBookingPage from './pages/VehicleBookingPage';
import PackagesPage from './pages/PackagesPage';
import RoutePage from './pages/RoutePage';
import AdminDashboard from './pages/AdminDashboard';
import AdminLeads from './pages/admin/Leads';
import AdminLogin from './pages/admin/AdminLogin';
import ProtectedRoute from './components/admin/ProtectedRoute';
import WhatsAppFloat from './components/layout/WhatsAppFloat';
import { Toaster } from './components/ui/sonner';

const AOSRefresh = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window.AOS !== 'undefined') {
      window.AOS.init({ duration: 700, once: true, offset: 80, easing: 'ease-out-cubic' });
      window.AOS.refresh();
    }
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (typeof window.AOS !== 'undefined') {
      window.AOS.init({ duration: 700, once: true, offset: 80, easing: 'ease-out-cubic' });
    }
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App page-wrapper">
          <AOSRefresh />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/book-vehicle" element={<VehicleBookingPage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/routes/:slug" element={<RoutePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={(
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/admin/leads"
            element={(
              <ProtectedRoute>
                <AdminLeads />
              </ProtectedRoute>
            )}
          />
        </Routes>
        <WhatsAppFloat />
        <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
